<style lang="scss" scoped>
.panel {
  height: 28px;
  color: #419fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: -25px;
}

.detail-target {
  margin-top: 24px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // 左侧
  .left {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }

  // 右侧
  .right {
    display: flex;
    align-items: center;
  }
}

.page {
  display: flex;
  justify-content: end;
  padding-top: 10px;
}
</style>

<template>
  <div>
    <!-- 信息说明 -->
    <div class="panel">
      每日10,13,16,23点同步数据
    </div>
    <!-- 表单 -->
    <div class="form">
      <el-form style="height:28px;" :model="searchForm" :inline="true" size="mini">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input format="yyyy-MM-dd" type="daterange" :start.sync="searchForm.startTime" :end.sync="searchForm.endTime"> </yi_time_input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getProductionEfficiency" plain>{{ $t('sousuo') }} </el-button>
          <el-button type="default" @click="resetSearch" plain style="margin-left: 10px;">
            {{ $t('chongzhi') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 效率明细 -->
    <div class="detail-target">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t('xiaolumingxi') }}</span>
      </div>
      <div class="right">
        <!-- <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportExcel"> </el-button> -->
      </div>
    </div>
    <div class="echart-table">
      <div class="table">
        <el-table :data="tableList" border size="mini" :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" v-loading="searchLoading" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
          <el-table-column v-for="(item, index) in table.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)">
            <template slot-scope="scope">
              <span v-if="['summaryTime'].includes(item.prop)" style="color: #606266">{{ scope.row[item.prop] }}</span>
              <span v-else>{{ scope.row.standardCapacityMap[item.prop] === undefined ? '-' : (scope.row.standardCapacityMap[item.prop] * 100).toFixed(2) + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <!-- 分页 -->
    <div class="page" v-if="tableList.length > 0">
      <el-pagination background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 50, 100]" :page-size.sync="pageSize" :current-page.sync="pageNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="table.tableData.length"> </el-pagination>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
// 获取当月1号
const now = new Date(); 
const oneOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
// 设置时间为凌晨0点0分0秒
oneOfMonth.setHours(0, 0, 0, 0);
// 获取当月最后一天
const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
// 设置时间为当天23点59分59秒 注意：毫秒数只能到999
endOfMonth.setHours(23, 59, 59, 999);
export default {
  name: 'web_customize_zhongshuo_report_produce_report_tab_productivity',
  data() {
    return {
      searchLoading: false,
      searchForm: {
        startTime: oneOfMonth.getTime(),
        endTime: endOfMonth.getTime()
      },
      pageNum: 1,
      pageSize: 10,
      tableList: [],
      // 能耗表格数据
      table: {
        tableData: [],
        tableColumn: this.defaultTableColumn
      },
      defaultTableColumn: [
        {
          label: 'riqi',
          prop: 'summaryTime'
        }
      ]
    };
  },
  created() {
    this.getProductionEfficiency();
  },
  methods: {
    // 页面显示条数改变时调用
    handleSizeChange(size) {
      this.pageNum = 1;
      this.page();
    },
    // 当前页改变时调用
    handleCurrentChange(num) {
      this.page();
    },
    // 分页函数
    page() {
      const startIndex = (this.pageNum - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.tableList = this.table.tableData.slice(startIndex, endIndex);
    },
    // 获取生产效率数据
    getProductionEfficiency() {
      this.searchLoading = true;
      this.http
        .get('/custom/zhongshuo/wo/report/record/statistical/production/efficiency', {
          params: this.searchForm
        })
        .then(res => {
          const data = res.data;
          let tableData = [];
          let colums = this.utils.copy(this.defaultTableColumn);
          if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              const d = data[i];
              const obj = {
                summaryTime: dayjs(d.summaryTime).format('YYYY-MM-DD'),
                standardCapacityMap: d.standardCapacityMap
              };
              tableData.push(obj);
              for (const key of Object.keys(d.standardCapacityMap)) {
                const column = {
                  label: key,
                  prop: key
                };
                colums.push(column);
              }
            }
            // 列label去重
            let map = new Map();
            let tableColumn = [];
            for (let item of colums) {
              if (!map.has(item.label)) {
                map.set(item.label, item);
                tableColumn.push({
                  label: item.label,
                  prop: item.prop
                });
              }
            }
            
            // 给label排序
            function isSpecialCh(key) {
              return key.indexOf("当") === 0;
            }
            tableColumn.sort((a, b) => {
              let o1 = a.label;
              let o2 = b.label;
              if (o1.indexOf("ri") === 0 || o2.indexOf("ri") === 0) {
                return 1;
              }
              if (isSpecialCh(o1) && !isSpecialCh(o2)) {
                return 1;
              } else if (!isSpecialCh(o1) && isSpecialCh(o2)) {
                  return -1;
              } else {
                  return o1.localeCompare(o2);
              }
            });
            colums = tableColumn;
          }
          this.table.tableData = tableData;
          this.table.tableColumn = colums;
          this.page();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        startTime: oneOfMonth.getTime(),
        endTime: endOfMonth.getTime()
      };
      this.getProductionEfficiency();
    },

    // 从嵌套对象中取值
    getValueByPath(obj, path) {
      const parts = path.split('.');
      let current = obj;
      for (let i = 0; i < parts.length; i++) {
        if (current[parts[i]] !== undefined) {
          current = current[parts[i]];
        } else {
          // 如果路径中的某一部分不存在，返回undefined
          return undefined;
        }
      }
      return current;
    }
  }
};
</script>
